var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5C5 6.80964 4.44036 6.25 3.75 6.25C3.05964 6.25 2.5 6.80964 2.5 7.5C2.5 8.19036 3.05964 8.75 3.75 8.75C4.44036 8.75 5 8.19036 5 7.5ZM11.25 7.5C11.25 6.80964 10.6904 6.25 10 6.25C9.30964 6.25 8.75 6.80964 8.75 7.5C8.75 8.19036 9.30964 8.75 10 8.75C10.6904 8.75 11.25 8.19036 11.25 7.5ZM17.5 7.5C17.5 6.80964 16.9404 6.25 16.25 6.25C15.5596 6.25 15 6.80964 15 7.5C15 8.19036 15.5596 8.75 16.25 8.75C16.9404 8.75 17.5 8.19036 17.5 7.5ZM5 12.5C5 11.8096 4.44036 11.25 3.75 11.25C3.05964 11.25 2.5 11.8096 2.5 12.5C2.5 13.1904 3.05964 13.75 3.75 13.75C4.44036 13.75 5 13.1904 5 12.5ZM11.25 12.5C11.25 11.8096 10.6904 11.25 10 11.25C9.30964 11.25 8.75 11.8096 8.75 12.5C8.75 13.1904 9.30964 13.75 10 13.75C10.6904 13.75 11.25 13.1904 11.25 12.5ZM17.5 12.5C17.5 11.8096 16.9404 11.25 16.25 11.25C15.5596 11.25 15 11.8096 15 12.5C15 13.1904 15.5596 13.75 16.25 13.75C16.9404 13.75 17.5 13.1904 17.5 12.5Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.b719ac68810229f6f56f20aeaa5e3e03.svg";
export { ForwardRef as ReactComponent };